import React, { useEffect, useState } from "react";
import SliderComp from "../components/slider";
import Typography from "@mui/material/Typography";
import BullBear from "../components/BullBear";
import { Box, createTheme } from "@mui/material";
import DenseTable from "../components/Table";
import BasicModal from "../components/Modal";
import ReviewCards from "../Sections/Reviews/ReviewCards";
import { ThemeProvider } from "@mui/styles";
import { getInsights } from "../Services/apiRoutes";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HistoryCards from "../Sections/Reviews/HistoryCards";
import "../App.css";
import CoinChannel from "./CoinChannel";
import { getCryptoLogoMap } from "../utils/utility";
import QuestionMarkSvg from '../components/QuestionMarkSvg'
import ToolTip from "../components/ToolTip";

function isMobile() {
  const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const tabletWidth = 430;

  return viewportWidth >= tabletWidth;
}

export default function Nlp() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#3f51b5",
      },
      secondary: {
        main: "#f50057",
      },
    },
    typography: {
      fontFamily: "Roboto, Arial",
    },
  });
  // Below code is for check screen-size;
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener to handle window resize
    window.addEventListener('resize', handleResize);

    // Initial check for mobile
    setIsMobile(window.innerWidth <= 768);

    // Clean up event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  //End  
  const [sentiments, setSentiments] = useState({});
  const [coinIcons, setCoinIcons] = useState({});
  const [toggleTable, setToggleTable] = useState(false);
  const [type, setType] = useState("top");

  useEffect(() => {
    fetchSentimentInsights();
  }, [toggleTable]);

  const fetchSentimentInsights = async () => {
    try {
      const data = await getInsights();
      let negativeCoin = data?.["most negative coin channel wise"].split(" ")?.[0];
      let positiveCoin = data?.["most positive coin channel wise"].split(" ")?.[0];

      (async function () {
        const coins = await getCryptoLogoMap([negativeCoin, positiveCoin]);
        // const coins = await getIcon(negativeCoin + "," + positiveCoin);

        let positiveCoinKey = coins?.data?.data?.[positiveCoin]?.[0].logo;
        let negativeCoinKey = coins?.data?.data?.[negativeCoin]?.[0].logo;


        setCoinIcons({
          positiveURL: positiveCoinKey,
          negativeURL: negativeCoinKey,
        });
      })();

      setSentiments(data);
    } catch (error) { }
  };

  const openTable = (type) => {
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = () => {
      window.onpopstate = undefined;
      setToggleTable(false);
    }
    setType(type);
    setToggleTable(true);
  };

  const closeTable = () => {
    window.onpopstate = undefined;
    window.history.back();
    setToggleTable(false);
  };

  return (
    <div
      style={{
        marginTop: "30px",
        marginBottom: "30px",
      }}
    >
      {!toggleTable && (
        <ToolTip arrow title={"At Auro Digital we have a deep expertise in Natural Language Processing that allows us to gauge the market sentiment of various cryptocurrencies on news and social media channels, that we correlate with Price action and share with our clients as ideational tools."} placement="top" enterTouchDelay={0}>

          <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "center" }}>
            <Typography sx={{ fontWeight: "bold", textAlign: "center" }} variant={isMobile ? "h5" : "h4"}>
              NLP Sentiment Analysis
            </Typography>
            <div style={{ marginLeft: "5px" }}>
              {
                isMobile ?
                  (
                    <QuestionMarkSvg />
                  ) : (
                    <div />
                  )}
            </div>
          </Box>
        </ToolTip>
      )}
      {!toggleTable && (
        <Typography sx={{ fontWeight: "medium", textAlign: "center", marginTop: "1.5vw", marginBottom: isMobile ? "5px" : "-2vw" }} variant={isMobile ? "h6" : "h5"}>
          Long-Short Debate
        </Typography>
      )}
      <BasicModal />

      {toggleTable ? (
        <CoinChannel type={type} closeTable={closeTable} />
      ) : (
        <>
          <BullBear score={sentiments?.["total average sentiment"]?.[0]} status={sentiments?.["total average sentiment"]?.[1]} />


          <Box
            className="all-cards"
            id="nlp-card-scrollable"
            sx={{
              // height: "500px",
              maxHeight: "500px",
              maxWidth: "1500px",
              margin: isMobile ? "9px" : "0 auto",
              overflow: "scroll",
            }}
          >
            {/* <ReviewCards /> */}
            <SliderComp sentiments={sentiments} iconURLs={coinIcons} handleTable={openTable} />
            <HistoryCards />
          </Box>
        </>
      )}
    </div>

  );
}
